import { render, staticRenderFns } from "./ModuleSelector.vue?vue&type=template&id=46ee551e"
import script from "./ModuleSelector.vue?vue&type=script&lang=js"
export * from "./ModuleSelector.vue?vue&type=script&lang=js"
import style0 from "./ModuleSelector.vue?vue&type=style&index=0&id=46ee551e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports